/**
 * FloatingBrandingBadge - A floating badge shown on photographer pages
 * 
 * Replaces "Made with Emergent" badge with "Built by 360Lumina"
 * 
 * Visibility Rules:
 * - Starter/Pro tiers: Always visible
 * - Studio/Legacy tiers: Never visible (hidden)
 * 
 * Props:
 * - planKey: The photographer's subscription tier (starter, pro, studio, legacy)
 */
import { Link } from "react-router-dom";
import { Camera } from "lucide-react";

const FloatingBrandingBadge = ({ planKey }) => {
  // For Studio and Legacy tiers, hide the badge entirely
  const isHighTier = planKey === "studio" || planKey === "legacy";
  
  if (isHighTier) {
    return null;
  }
  
  return (
    <Link
      to="/"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 px-3 py-2 bg-white/95 backdrop-blur-sm rounded-lg shadow-lg border border-gray-200 text-gray-700 text-xs font-medium hover:bg-white hover:shadow-xl transition-all duration-200"
      data-testid="floating-branding-badge"
    >
      <Camera className="w-4 h-4 text-primary" />
      <span>Built by 360Lumina</span>
    </Link>
  );
};

export default FloatingBrandingBadge;
